export const FETCH_INGREDIENTS = "FETCH_INGREDIENTS";
export const FETCH_INGREDIENTS_TAGS = "FETCH_INGREDIENTS_TAGS";
export const FETCH_UNITIES_TAGS = "FETCH_UNITIES_TAGS";
export const FETCH_INGREDIENT_IMAGES = "FETCH_INGREDIENT_IMAGES";
export const FETCH_RECIPES = "FETCH_RECIPES";
export const FETCH_RECIPE_IMAGES = "FETCH_RECIPE_IMAGES";
export const FETCH_RECIPE_TAGS = "FETCH_RECIPE_TAGS";
